/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useState, useEffect, useMemo, useCallback } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { DragDropContext, DropResult } from 'react-beautiful-dnd';
import { IDResource, IEvents } from 'types';
import { getUtcTime, timezone } from 'utils/helpers/momentTime';
import { IRootState } from 'store';
import { connect, useDispatch } from 'react-redux';
import { getResources } from 'actions/digital-resources';
import { getMergeEvents, getEvents } from 'actions/events';
// import { sendNotification } from 'actions/send-grid-notifications';
// import rateAnetapack from 'components/email-templates/rateAnetapack';
import { getAnetaPackById } from 'actions/aneta-pack';
import { unitMerge, clearUnitsErrors } from 'actions/scholars';
import moment from 'moment';
import _ from 'lodash';
import buttons from 'style/buttons.module.scss';
import ScheduleAnetapack from './schedule';
import Homeroom from './homeroom';
import styles from '../index.module.scss';

const mstp = (state: IRootState) => ({
  resourcesState: state.digitalResources,
  eventsData: state.events,
  scholars: state.scholars,
  anetaPack: state.anetaPack,
  activeScholarId: state.users.userData?.activeScholarId,
  userEmail: state.users.userData?.email,
});
interface AnetapackMergeProps extends ReturnType<typeof mstp> {
  date: Date;
  openPrev: () => void;
  selectedAnetaPackId: number;
  handleClose: () => void;
  searcIndex: (
    inputArray: moment.Moment[][],
    searchValue: string
  ) => number[] | null;
}

const AnetapackMerge: FC<AnetapackMergeProps> = ({
  selectedAnetaPackId,
  activeScholarId,
  resourcesState,
  handleClose,
  eventsData,
  searcIndex,
  anetaPack,
  // userEmail,
  scholars,
  openPrev,
  date,
}) => {
  const [step, setStep] = useState(1);
  const [events, setEvents] = useState<IEvents[] | []>(eventsData.mergeEvents);
  const [hasError, setError] = useState(true);

  const [eventsCollection, setEventsCollection] = useState(events || []);
  const [anetaPackSchedule, setAnetaPackSchedule] = useState<any>();
  const [errortimeEvents, setErrortimeEvents] = useState<IEvents[]>([]);
  const [resources, setResources] = useState<IDResource[]>([]);
  const [selectedDate, setSelectedDate] = useState(moment());
  const [resourcesAnetapack, setResourcesAnetapack] = useState<IDResource[]>(
    []
  );
  const [currentCategory, setCurrentCategory] = useState('Math');
  const [errorCategory, setErrorCategory] = useState('');
  const [isButtonActive, setIsButtonActive] = useState(true);
  const { units } = resourcesState;
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const currentKidName = useMemo(() => {
    const kid =
      activeScholarId && _.find(scholars.units, { id: +activeScholarId });
    return kid ? kid?.name : '';
  }, [activeScholarId, scholars]);

  const onSuccess = () => setError(!hasError);

  useEffect(() => {
    if (!anetaPack?.anetapackOptions?.schedule) {
      setStep(2);
    }
    setResourcesAnetapack(anetaPack?.currentAnetaPack?.digitalResources || []);
    setAnetaPackSchedule(
      _.flatten(_.values(anetaPack?.currentAnetaPack?.events))
    );
  }, [anetaPack]);

  useEffect(() => {
    if (selectedAnetaPackId) {
      dispatch(getAnetaPackById(selectedAnetaPackId));
      dispatch(clearUnitsErrors());
    }
  }, [selectedAnetaPackId, dispatch]);

  useEffect(() => {
    // get error time events
    const errorEvents: IEvents[] = [];
    eventsCollection.forEach((event) => {
      const startTime = moment(event.startTime, 'YYYY-MM-DD HH:mm');
      const endTime = moment(event.endTime, 'YYYY-MM-DD HH:mm');
      _.filter(eventsCollection, (el) => {
        const startTimeCurrent = moment(el.startTime, 'YYYY-MM-DD HH:mm');
        // if crossing of time or the same time - get this event
        if (
          el.id !== event.id &&
          ((moment(el.startTime, 'YYYY-MM-DD HH:mm')
            .add(timezone, 'minutes')
            .format('D-M-Y') ===
            moment(startTime).add(timezone, 'minutes').format('D-M-Y') &&
            moment(startTimeCurrent).isBetween(startTime, endTime)) ||
            moment(el.startTime, 'YYYY-MM-DD HH:mm').isSame(
              moment(event.startTime, 'YYYY-MM-DD HH:mm')
            ))
        ) {
          errorEvents.push(el);
        }
      });
    });
    setErrortimeEvents(_.uniq(errorEvents));
  }, [eventsCollection]);

  const onDragEndEvents = (result: DropResult) => {
    const { draggableId, destination, source } = result;
    const isDragingFromSecondBlock = source.droppableId.split('_')[0] === '2';
    if (!destination || destination.droppableId.split('_')[0] === '2') return;

    const newTimeFrom = destination.droppableId.split('_')[1];
    const newDate = destination.droppableId.split('_')[2];
    const timeRangeInMinutes = +draggableId.split('_')[1];
    const newEventsState = [...eventsCollection];
    const id = draggableId.split('_')[0];
    let currentEvent;
    // dragging events from right block
    if (isDragingFromSecondBlock) {
      currentEvent = _.find(anetaPackSchedule, (el) => {
        return el.id === +id;
      });
      // remove element from source array
      const newPackState = _.filter(anetaPackSchedule, (el) => {
        return el.id !== +id;
      });
      setAnetaPackSchedule(newPackState);
    } else {
      currentEvent = _.find(eventsCollection, (el) => {
        return el.id === +id;
      });
    }
    if (currentEvent) {
      const newTimeTo = moment(newTimeFrom, 'LT')
        .add(timeRangeInMinutes, 'minutes')
        .format('HH:mm');
      // add element to destination array & rewrite timeStamp
      currentEvent.startTime = getUtcTime(
        newTimeFrom,
        'LT',
        moment(newDate).toDate()
      );
      currentEvent.endTime = getUtcTime(
        newTimeTo,
        'HH:mm',
        moment(newDate).toDate()
      );
      currentEvent.startTimeStr = getUtcTime(newTimeFrom, 'hh:mm A');
      currentEvent.endTimeStr = getUtcTime(newTimeTo, 'HH:mm');
      currentEvent.date = `${moment(
        getUtcTime(newTimeFrom, 'LT', moment(newDate).toDate()),
        'YYYY-MM-DD HH:mm'
      ).format('YYYY-MM-DDT00:00:00.000')}Z`;
      if (isDragingFromSecondBlock) {
        newEventsState.push(currentEvent);
      }
      setEventsCollection(newEventsState);
    }
  };

  const removeEventFromSchedule = (eventId: number) => {
    const updatedEvents: IEvents[] = [];
    eventsCollection.forEach((e: IEvents) => {
      if (e.id !== eventId) {
        updatedEvents.push(e);
      }
    });
    setEventsCollection(updatedEvents);
  };

  const removeResourceFromSchedule = (id: number) => {
    const updatedLinks: IDResource[] = [];
    resources.forEach((e: IDResource) => {
      if (e.id !== id) {
        updatedLinks.push(e);
      }
    });
    setResources(updatedLinks);
  };

  const [visibleEvents, setVisibleEvents] = useState<IEvents[]>([]);

  const getVisibleEvents = (e: IEvents[]) => {
    setVisibleEvents(e);
  };

  const handleMoveAllEvents = () => {
    const eventsWithNewTime = _.map(visibleEvents, (el) => {
      const newStartTime = moment(
        `${selectedDate.format('YYYY-MM-DD')} ${el.startTimeStr}`,
        'YYYY-MM-DD HH:mm'
      )
        .add(timezone, 'minutes')
        .toISOString();
      const newEndTime = moment(
        `${selectedDate.format('YYYY-MM-DD')} ${el.endTimeStr}`,
        'YYYY-MM-DD HH:mm'
      )
        .add(timezone, 'minutes')
        .toISOString();
      return {
        ...el,
        startTime: newStartTime,
        endTime: newEndTime,
        date: `${selectedDate.format('YYYY-MM-DDT00:00:00.000')}Z`,
      };
    });
    if (!_.isEmpty(eventsWithNewTime)) {
      const updatedSchedule: IEvents[] = [];
      const ids = _.map(visibleEvents, (el) => el.id);
      anetaPackSchedule.forEach((el: IEvents) => {
        if (!_.includes(ids, el.id)) {
          updatedSchedule.push(el);
        }
      });

      setEventsCollection([...eventsCollection, ...eventsWithNewTime]);
      setAnetaPackSchedule(updatedSchedule);
      setVisibleEvents([]);
    }
  };

  const handleMoveAllResources = () => {
    if (!_.isEmpty(resourcesAnetapack)) {
      setResources([...resources, ...resourcesAnetapack]);
      setResourcesAnetapack([]);
    }
  };

  const getErrorMessage = useCallback(() => {
    let message = '';
    if (!_.isEmpty(errortimeEvents) && step === 1) {
      message = 'Please resolve time conflict.';
    }
    if (errorCategory && step === 2) {
      message = 'Maximum 6 elements in category.';
    }
    if (scholars.errors !== '') {
      message = scholars.errors;
    }
    return message;
  }, [errorCategory, errortimeEvents, scholars.errors, step]);

  const handleClickNext = async () => {
    if (step === 2 || (step === 1 && !anetaPack?.anetapackOptions?.homeroom)) {
      const formattedEvents = _.reduce(
        eventsCollection,
        (acc: any, n: IEvents) => {
          const currentCollection: IEvents[] = [];
          eventsCollection.forEach((el: IEvents) => {
            if (el.date === n.date) {
              currentCollection.push(el);
            }
            const dateFrom = `${moment(n.date).format('YYYY-MM-DD')} ${
              n.startTimeStr
            }`;
            const dateTo = `${moment(n.date).format('YYYY-MM-DD')} ${
              n.endTimeStr
            }`;
            return { ...n, startTime: dateFrom, endTime: dateTo };
          });
          acc[moment(n.date).toDate().getTime().toString()] = currentCollection;
          return acc;
        },
        {}
      );
      const requesData = {
        schedule: formattedEvents,
        digitalResources: resources,
      };
      if (activeScholarId) {
        setIsButtonActive(false);
        await dispatch(unitMerge(activeScholarId, requesData, onSuccess));
        dispatch(
          getEvents(
            activeScholarId,
            moment().clone().startOf('week').format(),
            moment(selectedDate).clone().add(7, 'days').format()
          )
        );
        // rate anetapack notification
        // if (anetaPack.currentAnetaPack && userEmail) {
        //   dispatch(
        //     sendNotification(
        //       [userEmail],
        //       rateAnetapack(anetaPack?.currentAnetaPack?.anetaPack.name)
        //     )
        //   );
        // }
      }
      if (!hasError) {
        handleClose();
        if (location.pathname !== '/onboarding/timetable') {
          history.push('/onboarding/timetable');
        }
      }
    }
    setStep(2);
  };

  useEffect(() => {
    if (!hasError) {
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasError]);

  const handleClickBack = () => {
    if (step === 1) {
      openPrev();
      handleClose();
    }
    if (step === 2 && !anetaPack?.anetapackOptions?.schedule) {
      openPrev();
      handleClose();
    }
    if (step === 2) {
      setStep(1);
    }
  };

  const savedResources = useMemo(
    () => (activeScholarId ? units[activeScholarId] : []),
    [activeScholarId, units]
  );

  useEffect(() => {
    if (activeScholarId && !_.isEmpty(savedResources)) {
      setResources(savedResources);
    }
  }, [resourcesState, activeScholarId, savedResources]);

  useEffect(() => {
    if (activeScholarId) {
      if (step === 2) {
        dispatch(getResources(activeScholarId));
      } else {
        dispatch(
          getMergeEvents(
            activeScholarId,
            moment(selectedDate).format(),
            moment(selectedDate).clone().add(1, 'days').format()
          )
        );
        setEvents(eventsData.mergeEvents);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeScholarId, selectedDate, step]);

  const onDragEndHomeRoom = (result: DropResult) => {
    const { draggableId, destination, source } = result;
    if (!destination || destination.droppableId === '2') return;
    const newHomeRoomState = [...resources];
    // remove element from source array
    if (source.droppableId === '2') {
      const currentElement = _.find(resourcesAnetapack, (el) => {
        return el.id === +draggableId;
      });
      const stateWithoutCurrentElement = _.filter(resourcesAnetapack, (el) => {
        return el.id !== +draggableId;
      });
      setResourcesAnetapack(stateWithoutCurrentElement);
      if (currentElement) {
        newHomeRoomState.push(currentElement);
        setResources(newHomeRoomState);
        // type available anyway
        if (currentElement) {
          setCurrentCategory(currentElement.type || '');
        }
      }
    }
  };
  useEffect(() => {
    const digitalResources = _.filter(
      resources,
      (el: IDResource) => el.ownerType !== 'event'
    );
    const result =
      digitalResources &&
      digitalResources.reduce((acc: any, n) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        acc[n.type!] = (acc[n.type!] ?? 0) + 1;
        return acc;
      }, {});
    if (result) {
      const key = _.findKey(result, (o) => o > 6);
      if (key) {
        setErrorCategory(key);
      } else {
        setErrorCategory('');
      }
    }
  }, [resources]);

  return (
    <div className={styles.anetapackContentRoot}>
      <div className={styles.anetapackContentHeader}>
        <span
          style={
            (!_.isEmpty(errortimeEvents) && step === 1) ||
            (errorCategory && step === 2) ||
            scholars.errors !== ''
              ? { color: '#E5225C' }
              : {}
          }
          className={`deep-gray-heading ${styles.smallHeader}`}
        >
          {(!_.isEmpty(errortimeEvents) && step === 1) ||
          (errorCategory && step === 2) ||
          scholars.errors !== ''
            ? getErrorMessage()
            : `Drag schedule items from the Shared Anetapack to add them to your
          scholar’s Schedule`}
        </span>
      </div>
      <div className={styles.anetapackContentMain}>
        {step === 1 ? (
          <DragDropContext
            onDragEnd={(result: DropResult) => onDragEndEvents(result)}
          >
            <div>
              <ScheduleAnetapack
                events={eventsCollection}
                searcIndex={searcIndex}
                dndId={1}
                removeEventFromSchedule={removeEventFromSchedule}
                errortimeEvents={errortimeEvents}
                anetaPackSchedule={_.flatten(
                  _.values(anetaPack?.currentAnetaPack?.events)
                )}
                setSelectedDate={setSelectedDate}
                currentKidName={currentKidName}
                startDate={moment(date).format('x')}
              />
            </div>
            <div>
              <ScheduleAnetapack
                searcIndex={searcIndex}
                anetaPack={anetaPackSchedule}
                handleMoveAll={handleMoveAllEvents}
                getVisibleEvents={getVisibleEvents}
                startDate={
                  Object.keys(anetaPack?.currentAnetaPack?.events)[0] || ''
                }
                dndId={2}
                anetaPackName={anetaPack?.currentAnetaPack?.anetaPack.name}
              />
            </div>
          </DragDropContext>
        ) : (
          <DragDropContext
            onDragEnd={(result: DropResult) => onDragEndHomeRoom(result)}
          >
            <div>
              <Homeroom
                removeResourceFromSchedule={removeResourceFromSchedule}
                resources={resources}
                dndId={1}
                currentCategory={currentCategory}
                errorCategory={errorCategory}
                currentKidName={currentKidName}
              />
            </div>
            <div>
              <Homeroom
                dndId={2}
                handleMoveAll={handleMoveAllResources}
                anetapackHomeRoom={resourcesAnetapack}
                currentCategory={currentCategory}
                anetaPackName={anetaPack?.currentAnetaPack?.anetaPack.name}
              />
            </div>
          </DragDropContext>
        )}
      </div>
      <div className={styles.anetapackContentButtons}>
        <button
          onClick={handleClickBack}
          className={buttons.buttonOutline}
          type="button"
          // disabled={!anetaPack?.anetapackOptions?.schedule}
        >
          Back
        </button>
        <button
          onClick={handleClickNext}
          disabled={
            (step === 1 && !_.isEmpty(errortimeEvents)) ||
            (step === 2 && !!errorCategory) ||
            !isButtonActive
          }
          className={buttons.buttomPrimary}
          type="button"
        >
          {step === 2 || (step === 1 && !anetaPack?.anetapackOptions?.homeroom)
            ? 'Apply'
            : 'Next'}
        </button>
      </div>
    </div>
  );
};

export default connect(mstp)(AnetapackMerge);
